var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 31H4.33333M4.33333 31H13.9167M4.33333 31V4.33333C4.33333 2.49238 5.82572 1 7.66667 1H24.3333C26.1743 1 27.6667 2.49238 27.6667 4.33333V31M13.9167 31V26H18.0833V31M13.9167 31H18.0833M27.6667 31H31M27.6667 31H18.0833M18.9167 6H22.25M18.9167 11H22.25M18.9167 16H22.25M18.9167 21H22.25M9.75 6H13.0833M9.75 11H13.0833M9.75 16H13.0833M9.75 21H13.0833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForCompanies);
export default __webpack_public_path__ + "static/media/for-companies.1a5026c9a36ac6bf63bb0a694ce2cca0.svg";
export { ForwardRef as ReactComponent };